<script>
    import User from "./data/User";
    import UserValidator from "./data/UserValidator";

    export default {
        name: "user-wizard-user-type-field",
        props: {
            user: {type: User, required: true},
            validator: {type: UserValidator, required: true},
            disabled: {type: Boolean}
        },
        computed: {
            label() {
                return Lang.langGet('User Type');
            },
            value() {
                if (this.user.isLdap) return this.user.types.find(type => type.value === 'ldap');
                if (this.user.isExternal) return this.user.types.find(type => type.value === 'external');
                if (this.user.isLinked) return this.user.types.find(type => type.value === 'linked');
                return this.user.types.find(type => type.value === 'default');
            },
            socialiteItems() {
                return [{value: 'socialite', text: Lang.langGet('Linked via') + ' ' + this.user.socialiteProvider }];
            }
        },
        methods: {
            handleChange(value) {
                if (value === 'ldap') {
                    this.user.isLinked = false;
                    this.user.isLdap = true;
                    this.user.isExternal = false;
                    this.user.firstName = 'LDAP Role';
                    this.user.lastName = undefined;
                    this.user.password = '%UserPasswor6%';
                    this.user.passwordConfirmation = '%UserPasswor6%';

                    this.validator.update('firstName', true);
                    this.validator.update('passwords', true);
                }
                if (value === 'external') {
                    this.user.isLinked = false;
                    this.user.isLdap = false;
                    this.user.isExternal = true;
                    this.user.firstName = 'External User';
                    this.user.lastName = undefined;
                    this.user.password = '%UserPasswor6%';
                    this.user.passwordConfirmation = '%UserPasswor6%';

                    this.validator.update('firstName', true);
                    this.validator.update('passwords', true);
                    if (_.isEmpty(this.user.email)) {
                        this.validator.update('email', true);
                    }
                }
                if (value === 'default') {
                    this.user.isLinked = false;
                    this.user.isLdap = false;
                    this.user.isExternal = false;
                    this.user.firstName = undefined;
                    this.user.lastName = undefined;
                    this.user.password = null;
                    this.user.passwordConfirmation = null;

                    this.validator.update('firstName', false);
                    if (_.isEmpty(this.user.email)) {
                        this.validator.update('email', false);
                    }
                }
                if (value === 'linked') {
                    this.user.isLinked = true;
                    this.user.isLdap = false;
                    this.user.isExternal = false;
                    this.user.firstName = 'External User';
                    this.user.lastName = 'External User';
                    this.user.password = '%UserPasswor6%';
                    this.user.passwordConfirmation = '%UserPasswor6%';

                    this.validator.update('firstName', true);
                    this.validator.update('lastName', true);
                    this.validator.update('passwords', true);
                    if (_.isEmpty(this.user.email)) {
                        this.validator.update('email', false);
                    }
                }
            }
        }
    }
</script>

<template>
    <v-select-custom v-if="user.socialiteProvider"
        disabled
        :value="socialiteItems[0]"
        :items="socialiteItems"
        :label="label"
        popup-used-in-modal
    />
    <v-select-custom v-else
        :disabled="disabled"
        :value="value"
        @input="handleChange"
        :items="user.getUserTypes()"
        :label="label"
        popup-used-in-modal
    />
</template>

